export const LOADER_STATUS = 'boilerplate/IMS_SAVE/LOADER_STATUS';
export const SAVE_TABLE_DATA = 'boilerplate/IMS_SAVE/SAVE_TABLE_DATA';
export const COMPARATIVE_TABLE_DATA = 'boilerplate/IMS_SAVE/COMPARATIVE_TABLE_DATA';



